// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// Add here your keycloak setup infos
const keycloakConfig = {
  url: 'https://keycloak.lan.copas.nl/auth',
  realm: 'Copas',
  clientId: 'builds-frontend'
};

export const environment = {
    production: false,
    keycloak: keycloakConfig,
    //api: 'http://localhost:8080/api'
    api: 'https://builds.lan.copas.nl/api'
  }


